<template>
  <Modal
    ref="suggestedSchoolModal"
    size="md"
    anchor="mid"
    width="4">
    <template #title>
      <h2 class="p-2 text-center mx-auto">Existing School/Programs</h2>
    </template>
    <template #content>
      <div class="mt-6 space-y-2 p-2">
        <BuildingItem
          v-for="(item, index) in suggestedSchools"
          :key="index"
          :item="item"
          :selected="item.id == selected"
          @changeSelected="selected = $event"
        />
      </div>
    </template>
    <template #footer="slotProps">
      <Button
        type="submit"
        color="blue"
        size="md"
        class="rounded-md font-medium px-3 py-2 shadow-sm disabled:bg-gray-100 disabled:text-gray-400"
        :disabled="selected == -1"
        @click="onSelectSchoolClick(slotProps)">
        Select this school/program instead
      </Button>
    </template>
  </Modal>
</template>

<script>
import Modal from '../Modal.vue'
import Button from '../Button.vue'

import BuildingItem from '../items/BuildingItem.vue'

function addressEquals(a, b) {
  if (a.apartment) {
    if (b.apartment) {
      return a?.street.trim().toLowerCase() === b?.street.trim().toLowerCase() &&
        a?.apartment.trim().toLowerCase() === b?.apartment.trim().toLowerCase() &&
        a?.city.trim().toLowerCase() === b?.city.trim().toLowerCase() &&
        a?.state.trim().toLowerCase() === b?.state.trim().toLowerCase() &&
        a?.zip_code.trim().toLowerCase() === b?.zip_code.trim().toLowerCase()
    }
    else {
      return false
    }
  }
  else {
    if (b.apartment) {
      return false
    }
    else {
      return a?.street.trim().toLowerCase() === b?.street.trim().toLowerCase() &&
        a?.city.trim().toLowerCase() === b?.city.trim().toLowerCase() &&
        a?.state.trim().toLowerCase() === b?.state.trim().toLowerCase() &&
        a?.zip_code.trim().toLowerCase() === b?.zip_code.trim().toLowerCase()
    }
  }
}

export default {
  components: {
    Modal,
    Button,
    BuildingItem,
  },
  props: {
    schoolList: Array,
  },
  data() {
    return {
      selected: -1,
      suggestedSchools: [],

      previousData: {
        name: undefined,
        address: undefined,
      }
    }
  },
  methods: {
    hideModal() {
      this.$bvModal.hide('suggestedSchoolModal')
      // this.$refs['suggestedSchoolModal'].hide()
    },
    resetPreviousData() {
      this.previousData = {
        name: undefined,
        address: undefined,
      }
    },
    onSelectSchoolClick(slotProps) {
      this.$emit('select', this.selected)
      slotProps.closeModal(true)
    },
    showSuggestedSchools(newSchoolInfo, newAddress) {
      // since the TransDetail school list filters by whether a building name exists in the
      //   list, filtering on school name here is moot.
      if (newSchoolInfo === undefined || newSchoolInfo === null) {
        this.suggestedSchools = []
        return
      }

      if (this.previousData.name && this.previousData.name === newSchoolInfo.name) {
        if (newAddress) {
          if (this.previousData.address && addressEquals(this.previousData.address, newAddress)) {
            return
          }
        }
        else if (newSchoolInfo.address) {
          if (this.previousData.address && addressEquals(this.previousData.address, newSchoolInfo.address)) {
            return
          }
        }
        else {
          return
        }
      }

      this.suggestedSchools = this.schoolList.filter(school => {
        if (newSchoolInfo.id && school.id === newSchoolInfo.id) {
          return false
        }
        else {
          if (newSchoolInfo.address) {
            return addressEquals(newSchoolInfo.address, school.address) || newSchoolInfo.name === school.name
          }
          else if (newAddress) {
            return addressEquals(newAddress, school.address) || newSchoolInfo.name === school.name
          }
          else {
            return newSchoolInfo.name === school.name
          }
        }
      })

      //this.previousData.name = newSchoolInfo.name
      //if (newSchoolInfo.address) {
      //  this.previousData.address = newSchoolInfo.address
      //}
      //else if (newAddress) {
      //  this.previousData.address = newAddress
      //}

      if (this.suggestedSchools.length > 0) {
        // if modal is opened, save prev data to prevent modal spam
        this.previousData.name = newSchoolInfo.name
        if (newSchoolInfo.address) {
          this.previousData.address = newSchoolInfo.address
        }
        else if (newAddress) {
          this.previousData.address = newAddress
        }

        this.$refs.suggestedSchoolModal.openModal()
      }
    },
  },
  computed: {
    disableChangeStatusButton() {
      return this.dbId === -1 || this.statusFromServer === 'unknown'
    },
  },
}
</script>
